<template>
  <div v-if="!$tools.isEmpty(phone)" :class="$tools.isDefined(block) ? '' : 'd-inline-block'">
    <div v-if="$tools.isDefined(small)">
      <tooltip-view bottom>
        <template v-slot:action>
          <span class="clickable">
            {{$tools.phoneFormat(phone)}}<v-icon small class="mt-n1">mdi-menu-down</v-icon>
          </span>
        </template>
        <template v-slot:content>
          <div>
            <div class="mb-2">
              <v-btn @click="$store.commit('call', phone)" small depressed block>Звонок</v-btn>
            </div>
            <div class="mb-2">
              <v-btn
                @click.stop="
                  $tools.storageSet('contactCenter_chat_search',$tools.phoneFormat(phone, true));
                  $router.push('/contactCenter/chat/')
                " small depressed block>Чат</v-btn>
            </div>
            <div class="mb-2">
              <v-btn
                  @click.stop="$tools.copyToClipboard($tools.phoneFormat(phone));$store.commit('alertSuccess', 'Скопировано: '+$tools.phoneFormat(phone));"
                  small depressed block>Скопировать</v-btn>
            </div>
          </div>
        </template>
      </tooltip-view>
    </div>
    <div v-else-if="!$tools.isDefined(big)" :class="$tools.isDefined(block) ? '' : 'd-inline-block'">
      <v-row no-gutters class="flex-nowrap">
        <v-col>
          <v-btn
              @click="$store.commit('call', phone)"
              :class="$tools.isFullPhone(phone) ? 'rounded-r-0' : ''" small depressed
              block
          >
            <v-icon class="mr-2" small>mdi-phone-outline</v-icon>
            <span style="text-transform: initial !important">{{typeof title==='undefined' ? $tools.phoneFormat(phone) : title}}</span>
            <v-spacer/>
          </v-btn>
        </v-col>
        <v-col v-if="$tools.isFullPhone(phone)" cols="auto">
          <v-btn
              @click.stop="
                $tools.storageSet('contactCenter_chat_search',$tools.phoneFormat(phone, true));
                $router.push('/contactCenter/chat/')
              "
              class="rounded-0" small depressed
          >
            <v-icon small class="mx-n1" color="grey">mdi-message-text-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="$tools.isFullPhone(phone)" cols="auto">
          <v-btn
              @click.stop="$tools.copyToClipboard($tools.phoneFormat(phone));$store.commit('alertSuccess', 'Скопировано: '+$tools.phoneFormat(phone));"
              class="rounded-l-0" small depressed
          >
            <v-icon size="14" class="mx-n1" color="grey">mdi-content-copy</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else class="flex-nowrap" :class="$tools.isDefined(block) ? '' : 'd-inline-block'">
      <v-row no-gutters>
        <v-col>
          <v-btn
              @click="$store.commit('call', phone)"
              :class="$tools.isFullPhone(phone) ? 'rounded-r-0' : ''" depressed
              block
          >
            <v-icon small class="mr-2">mdi-phone-outline</v-icon>
            <span style="text-transform: initial !important">{{typeof title==='undefined' ? $tools.phoneFormat(phone) : title}}</span>
            <v-spacer/>
          </v-btn>
        </v-col>
        <v-col v-if="$tools.isFullPhone(phone)" cols="auto">
          <v-btn
              @click.stop="
                $tools.storageSet('contactCenter_chat_search',$tools.phoneFormat(phone, true));
                $router.push('/contactCenter/chat/')
              "
              class="rounded-0" depressed
          >
            <v-icon small class="mx-n1" color="grey">mdi-message-text-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="$tools.isFullPhone(phone)" cols="auto">
          <v-btn
              @click.stop="$tools.copyToClipboard(phone);$store.commit('alertSuccess', 'Скопировано: '+$tools.phoneFormat(phone));"
              class="rounded-l-0" depressed
          >
            <v-icon small class="mx-n1" color="grey">mdi-content-copy</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>

</template>

<script>
import TooltipView from "@/components/TooltipView.vue";

export default {
  components: {TooltipView},
  props: ['phone', 'big', 'title','block','small']
}
</script>
